<app-avatar-preview [profileType]="profileType" [url]="avatarUrl" class="avatar"></app-avatar-preview>
<div class="content">
  <ng-content></ng-content>
</div>
